import { createSlice } from "@reduxjs/toolkit";

const projectDynamosSlice = createSlice({
  name: "projectDynamos",
  initialState: {
    byProjectId: {},
    loading: false,
    error: null,
  },
  reducers: {
    fetchProjectDynamosRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    fetchProjectDynamosSuccess: (state, action) => {
      const { projectId, drafts, published } = action.payload;
      state.loading = false;
      state.byProjectId[projectId] = {
        drafts: drafts || [],
        published: published || [],
      };
      state.error = null;
    },
    fetchProjectDynamosFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createProjectDynamoRequest: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    createProjectDynamoSuccess: (state, action) => {
      const { projectId, dynamo } = action.payload;
      state.loading = false;
      const existing = state.byProjectId[projectId] || { drafts: [], published: [] };
      if (dynamo.status === "published") {
        existing.published = [dynamo, ...(existing.published || [])];
      } else {
        existing.drafts = [dynamo, ...(existing.drafts || [])];
      }
      state.byProjectId[projectId] = existing;
    },
    createProjectDynamoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateProjectDynamoRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateProjectDynamoSuccess: (state, action) => {
      const { projectId, dynamo } = action.payload;
      state.loading = false;
      const existing = state.byProjectId[projectId] || { drafts: [], published: [] };
      // Remove from both lists then re-insert based on status
      const filterOut = (list) => (list || []).filter((d) => d.id !== dynamo.id);
      const drafts = filterOut(existing.drafts);
      const published = filterOut(existing.published);
      if (dynamo.status === "published") {
        existing.published = [dynamo, ...published];
        existing.drafts = drafts;
      } else {
        existing.drafts = [dynamo, ...drafts];
        existing.published = published;
      }
      state.byProjectId[projectId] = existing;
    },
    updateProjectDynamoFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    createLapRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    createLapSuccess: (state, action) => {
      const { projectId, dynamoId, lap } = action.payload;
      state.loading = false;
      const projectDynamos = state.byProjectId[projectId];
      if (!projectDynamos) return;
      const updateList = (list) =>
        (list || []).map((d) => {
          if (d.id !== dynamoId) return d;
          const laps = d.laps || { drafts: [], published: [] };
          if (lap.status === "published") {
            return {
              ...d,
              laps: {
                drafts: laps.drafts,
                published: [lap, ...(laps.published || [])],
              },
            };
          }
          return {
            ...d,
            laps: {
              drafts: [lap, ...(laps.drafts || [])],
              published: laps.published || [],
            },
          };
        });
      state.byProjectId[projectId] = {
        drafts: updateList(projectDynamos.drafts),
        published: updateList(projectDynamos.published),
      };
    },
    createLapFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    updateLapRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateLapSuccess: (state, action) => {
      const { projectId, dynamoId, lap } = action.payload;
      state.loading = false;
      const projectDynamos = state.byProjectId[projectId];
      if (!projectDynamos) return;
      const updateList = (list) =>
        (list || []).map((d) => {
          if (d.id !== dynamoId) return d;
          const laps = d.laps || { drafts: [], published: [] };
          const filterOut = (arr) => (arr || []).filter((l) => l.id !== lap.id);
          let drafts = filterOut(laps.drafts);
          let published = filterOut(laps.published);
          if (lap.status === "published") {
            published = [lap, ...published];
          } else {
            drafts = [lap, ...drafts];
          }
          return {
            ...d,
            laps: { drafts, published },
          };
        });
      state.byProjectId[projectId] = {
        drafts: updateList(projectDynamos.drafts),
        published: updateList(projectDynamos.published),
      };
    },
    updateLapFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchProjectDynamosRequest,
  fetchProjectDynamosSuccess,
  fetchProjectDynamosFailure,
  createProjectDynamoRequest,
  createProjectDynamoSuccess,
  createProjectDynamoFailure,
  updateProjectDynamoRequest,
  updateProjectDynamoSuccess,
  updateProjectDynamoFailure,
  createLapRequest,
  createLapSuccess,
  createLapFailure,
  updateLapRequest,
  updateLapSuccess,
  updateLapFailure,
} = projectDynamosSlice.actions;

export default projectDynamosSlice.reducer;

